import xhr from '../../tools/xhr.js';
import auth from '../../tools/storage.js';
import tools from '../../tools/tools.js';
import constants from '../../tools/constants.js';
import bodyMarkup from './b2bUserList.js';
import bodyMarkupStackfrom from './stack.js';
import markupUploadLists from './uploadsLists.js';
import markupLocationsLists from './locationsList.js';
import toolsMarkup from '../../markup/tools.js';
import btn from './reportExportEXCEL.js';
import uploadsLists from './uploadsLists.js';





// import filmApplicationsForConsider from '../lk/filmApplicationsForConsider.js';

// import auth from '../tools/storage.js';

const loaderSpinnerId = '';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

// const navMenuLineTabs = document.querySelector('#list-tab');

const mainTabPane = document.querySelector('#b2bDocsParntersCimena');
const htmlBody = mainTabPane.querySelector('div[name=body]');
const htmlBodyWinner = mainTabPane.querySelector('div[name=winner]');

const spinnerArea = mainTabPane.querySelector('#spinnerb2bDocs');

const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBTDataDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTDataUserFilter = mainTabPane.querySelector('button[name=typeDataUser]');
const universalViewSearchFiled = mainTabPane.querySelector('input[name=search]');



universalViewSearchFiled.addEventListener('keyup', () => reDisplayData());

const menuBt = document.querySelector('#Menub2bDocsParntersCimena');

// const body = document.querySelector('body');
const oneCard = document.querySelector('#b2bCard');
const allbtns = oneCard.querySelector('div[action=changeStatus]').querySelectorAll('button');
const oneCardTypeLocationDisplay = oneCard.querySelector('button[name=typeDisplayLocations]');



let winnerFilms = [];
let allb2bUsers = [];
let cntUsers = false;
let ownID = false;
let oneCardData = false;
let currentOneCardID = false;
let cardLocations  = [];



oneCardTypeLocationDisplay.addEventListener('click' , (evt) => {
    let typeDataDisplay = oneCardTypeLocationDisplay.value;
    // mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);


    ++typeDataDisplay;
    if (typeDataDisplay === 2)
      typeDataDisplay = 0;

    if(typeDataDisplay == 1) {
      oneCardTypeLocationDisplay.innerHTML = 'Отобразить описание площадок';
    } else {
      oneCardTypeLocationDisplay.innerHTML = 'Скрыть описание площадок';
    }
    oneCardTypeLocationDisplay.value = typeDataDisplay;
    
    if (cardLocations) 
      markupLocationsLists.drawDataInContainer(cardLocations, cardUploads);
    else  
      oneCard.querySelector('div[name=locationsBody]').innerHTML = '<b class="txt-al-center w-100">Площадок пока нет!</div>';

});

htmlBody.addEventListener('click', (evt) => {
  // console.log(evt.target.attributes);
  if(evt.target.attributes.requestid){
    currentOneCardID = evt.target.attributes.requestid.nodeValue;
    // evt.target.classList.add('lastOpened');
    reDisplayData();
    loadCard();
  }
});

function loadCard () {
  xhr.request = {
    metod: 'GET',
    url: `b2b/x/user/${currentOneCardID}/card`,
    data: '',
    callbackSuccess: (answer) => {
       if(answer.status && answer.data){
          showCard(answer.data);
      };
    }
  }
}
function getNameCntUser(allCntUser, userID){
    for (let p = 0; p < allCntUser.length; ++p){
      if(allCntUser[p].id == userID)
        return allCntUser[p].name;
    }

    return '-';
  };


function  getColorCntUser(allCntUser, userID){
    let colorsClass = [ 'light-blue',
                        'light-purple', 
                        'light-yellow', 
                        'light-coral',
                        'light-salmon',
                        'light-seagreen'];


    for (let p = 0; p < allCntUser.length; ++p){
      if(allCntUser[p].id == userID)
        return 'cloud-stack-' + colorsClass[p];
    }

    return 'cloud-stack-white';
  };

function showCard(data) {

  oneCardData = data ? data : false;
  if (oneCardData) {
    let generalInfo = oneCardData.generals ? oneCardData.generals : [];

    Object.keys(generalInfo).forEach((cElement) => {
      if(cElement.includes('hone')){
        oneCard.querySelector('div[name=' + cElement + ']').innerHTML = tools.formatedPhone('7'+ generalInfo[cElement]);

      }else if(cElement.includes('ime')) {
        oneCard.querySelector('div[name=' + cElement + ']').innerHTML = tools.dateStringFullAddTimeZone(generalInfo[cElement], 3);
      }else if(cElement.includes('generalType')) {
        let arrNameGeneralTypes = ['Директор','Генеральный директор', 'И. о. генерального директора', 'И. о. директора','Заместитель директора', 'Заместитель генерального директора'];
        oneCard.querySelector('label[name=generalType]').innerHTML = arrNameGeneralTypes[parseInt(generalInfo[cElement])] + ':';
      }else if(cElement.includes('msg')) {
        oneCard.querySelector('textarea[name=' + cElement + ']').value = generalInfo[cElement];

      } else if(oneCard.querySelector('div[name=' + cElement + ']')){
        oneCard.querySelector('div[name=' + cElement + ']').innerHTML = generalInfo[cElement];
      }

      oneCard.querySelector('div[name=statusName]').innerHTML = constants.statusB2BRequestCards.find(o => o.status == generalInfo.status).name;
      oneCard.querySelector('div[name=statusName]').style.backgroundColor="#" + constants.statusB2BRequestCards.find(o => o.status == generalInfo.status).color;
      // oneCard.querySelector('h4[name=statusName]').innerHTML = statusName[7];

      if(generalInfo.cntUserIDfk == null){
        oneCard.querySelector('div[name=cntUserName]').innerHTML = ' Не назначен!' ;
        oneCard.querySelector('div[name=cntUserName]').className = "user-label p-1";
      } else {
        oneCard.querySelector('div[name=cntUserName]').innerHTML = getNameCntUser(cntUsers,generalInfo.cntUserIDfk);
        oneCard.querySelector('div[name=cntUserName]').className = "user-label bold p-1 txt-al-center mlr-auto";
        oneCard.querySelector('div[name=cntUserName]').classList.add(getColorCntUser(cntUsers,generalInfo.cntUserIDfk));
      }
    });

    let cardUploads = oneCardData.uploads ? oneCardData.uploads :false;

    if (cardUploads) 
      markupUploadLists.drawDataInContainer(cardUploads);
    else  
      oneCard.querySelector('div[name=uploadBody]').innerHTML = '<b class="txt-al-center w-100">Документов пока нет!</div>';


    cardLocations = oneCardData.locations ? oneCardData.locations :false;

    if (cardLocations) 
      markupLocationsLists.drawDataInContainer(cardLocations, cardUploads);
    else  {
      oneCard.querySelector('b[name=totalLocations').innerHTML = '';
      oneCard.querySelector('div[name=locationsBody]').innerHTML = '<b class="txt-al-center w-100">Площадок пока нет!</div>';
    }

//  пскрыть кнопки дейстий, отобразить только нужные 

      allbtns.forEach((button) => {

        if(button.attributes.curstatus.nodeValue == generalInfo.status || (button.attributes.curstatus.nodeValue > 93 && generalInfo.status < 99))
          button.hidden = false;
        else
          button.hidden = true;

      });

      if(ownID == generalInfo.cntUserIDfk)
        oneCard.querySelector('div[name=block_btns]').hidden = false;
      else 
        oneCard.querySelector('div[name=block_btns]').hidden = true;


    setTimeout(function() { 
      $(oneCard).modal('show');
    }, 100);
  }
}

oneCard.querySelector('button[name=sendMSG]').addEventListener('click', (evt) => {
  if(confirm('Вы уверены, что хотите отправить ему сообщение?')){
    xhr.request = {
      metod: 'PUT',
      url: `b2b/x/user/${currentOneCardID}/card`,
      data: 'userMSG=' + oneCard.querySelector('textarea[name=msg]').value,
      callbackSuccess: (answer) => {

         if(answer.status && answer.data){
          $(oneCard).modal('hide');
          getMainData();
        };
      }
    }
  }
});


oneCard.querySelector('button[name=sendSMSALERT]').addEventListener('click', (evt) => {
  if(confirm('Вы уверены, что хотите отправить уведомление по СМС?')){
    xhr.request = {
      metod: 'GET',
      url: `b2b/x/user/${currentOneCardID}/sendsms`,
      data: '',
      callbackSuccess: (answer) => {
        tools.showAlert('SMS отправлено!');
      }
    }
  }
});

oneCard.querySelector('div[name=uploadBody]').addEventListener('click', (evt) => {
  if(evt.target.attributes.upid){
  
    if(confirm('Подтвердите данное действие:')){
        let comment = prompt('Вы можете указать комментарий к своему решению! \nЕсли хоите оставить пустой комментарий, то просто нажмите "ОК"!');
        if(!comment) 
          comment = ' ';
        
        xhr.request = {
          metod: 'PUT',
          url: `b2b/x/user/${currentOneCardID}/upload/${evt.target.attributes.upid.nodeValue}`,
          data: 'upStatus=' + evt.target.attributes.newstatus.nodeValue +'&upComment='+comment,
          callbackSuccess: (answer) => {

             if(answer.status && answer.data){
              $(oneCard).modal('hide');
              // getMainData();
              showCard(answer.data);
            };
          }
        }

        



        console.log(comment);

    
    }

  }
});

oneCard.querySelector('div[action=changeStatus]').addEventListener('click', (evt) => {

  if(evt.target.attributes.nextStatus){
    if(confirm('Вы уверены, что хотите изменить статус?')){
      xhr.request = {
        metod: 'PUT',
        url: `b2b/x/user/${currentOneCardID}/card`,
        data: 'userStatus=' + evt.target.attributes.nextStatus.nodeValue,
        callbackSuccess: (answer) => {

           if(answer.status && answer.data){
            $(oneCard).modal('hide');
            getMainData();
          };
        }
      }
    }
  } 

});


oneCard.querySelector('button[name=makeMeCurrator]').addEventListener('click', (evt) => {
  // if(evt.target.attributes.requestid)
  if(confirm('Вы уверены, что хотите стать куратором данной заявки?')){
    xhr.request = {
      metod: 'PUT',
      url: `b2b/x/user/${currentOneCardID}/card`,
      data: 'cntUserIDfk=' + ownID,
      callbackSuccess: (answer) => {

         if(answer.status && answer.data){
          $(oneCard).modal('hide');
          getMainData();
            setTimeout(function() { 
              showCard(answer.data);
            }, 1000);
        };
      }
    }
  }
});



function getMainData () {

  htmlBody.innerHTML = toolsMarkup.getWaitSpinner(loaderSpinnerId, loaderSpinnerMessage);

  if(cntUsers)

    xhr.request = {
    metod: 'GET',
    url: `b2b/x/users/`,
    data: '',
    callbackSuccess: (answer) =>{
      allb2bUsers = answer.data;
      reDisplayData();
      }
    };
  else 
    xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/usersb2b`,
      data: '',
      callbackSuccess: (answer) => {
         if(answer.status && answer.data){
            cntUsers = answer.data.users ? answer.data.users : [];
            ownID = answer.data.me ? answer.data.me : false;
            getMainData();
        };
      }
    };

  xhr.request = {
    metod: 'GET',
    url: `b2b/x/winnerlist/`,
    data: '',
    callbackSuccess: (answer) =>{
      winnerFilms = answer.data;
      reDisplayDataWinner();
    }
  };

}

mainTabPaneBTReload.addEventListener('click', () => {
  getMainData();
})


mainTabPaneBTDataDisplay.addEventListener('click', () => {

  let typeDataDisplay = mainTabPaneBTDataDisplay.value;
  mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 4)
    typeDataDisplay = 0;

  mainTabPaneBTDataDisplay.value = typeDataDisplay;
  mainTabPaneBTDataDisplay.classList.add(`iconDataDisplay${typeDataDisplay}`);
  
  reDisplayData();

});


mainTabPaneBTDataUserFilter.addEventListener('click', () => {

  let typeDataDisplay = mainTabPaneBTDataUserFilter.value;
  mainTabPaneBTDataUserFilter.classList.remove(`iconDataUser-${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 3)
    typeDataDisplay = 0;

  mainTabPaneBTDataUserFilter.value = typeDataDisplay;
  mainTabPaneBTDataUserFilter.classList.add(`iconDataUser-${typeDataDisplay}`);
  
  reDisplayData();

});

function reDisplayDataWinner() {
  let tableWinner = '<table class="border-black"><tr><td class="p-1">Фильм</td><td class="p-1">кол-во побед</td></tr>';
  if(winnerFilms) 
    winnerFilms.forEach((element) => {
       tableWinner += '<tr><td class="p-1">' + element.filmName + '</td><td class="p-1">' + element.countWinner + '</td></tr>';
    });
  tableWinner += '</table>';

  htmlBodyWinner.innerHTML = tableWinner;

}

function reDisplayData () {
  let filttredAllB2BUsers =  [];

  if (mainTabPaneBTDataUserFilter.value == 1)
    filttredAllB2BUsers = allb2bUsers.filter((row) => parseInt(row.cntUserIDfk) ==  parseInt(ownID));
  else if (mainTabPaneBTDataUserFilter.value == 2)
    filttredAllB2BUsers = allb2bUsers.filter((row) => row.cntUserIDfk == null);
  else
    filttredAllB2BUsers = allb2bUsers;
  

  if(filttredAllB2BUsers){
    if(universalViewSearchFiled.value.length == 0)
      bodyMarkupStackfrom.drawDataInContainer(filttredAllB2BUsers, cntUsers,ownID, currentOneCardID);
    else{
      let searchedData = [];

      filttredAllB2BUsers.forEach((element) => {
        if(tools.kmpSearch(universalViewSearchFiled.value,element.name ) != -1) // поиск по названию фильма
          searchedData.push(element);
      });
      
      bodyMarkupStackfrom.cleanContainer();

      if(searchedData.length == 0)
        bodyMarkupStackfrom.drawMarkupInContainer(`<p style="color:black;">Поиск не дал результатов</p>`)
      else
        bodyMarkupStackfrom.drawDataInContainer(searchedData, cntUsers,ownID, currentOneCardID);
    }
  } else
    bodyMarkupStackfrom.drawDataInContainer([], [],0);
}



export default {

  start() {
    menuBt.addEventListener('click', getMainData);
  },

  reloadData(){
    getMainData()
  },

 
  stop() {
    // bodyMarkup.cleanContainer();
  }
};
